import * as React from 'react';

import { IItem, IEditProps } from '../types';

import Form from './Form';

export default class Edit extends React.Component<IEditProps> {
  onSubmit = async (values: IItem, withWarnings: boolean) => {
    this.props.preventClosing(false);
    await this.props.update(values, withWarnings);
    this.props.closeRow();
  };

  render() {
    const { item, ...props } = this.props;
    return (
      <Form
        id={item.id}
        initialValues={item}
        onSubmit={this.onSubmit}
        {...props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Items/components/Edit.tsx